// extracted by mini-css-extract-plugin
export var footer = "_n3-5";
export var fulfillmentInput = "_n3-0";
export var shipDateInput = "_n3-1";
export var shipmentModal = "_n3-2";
export var shipmentModalContent = "_n3-3";
export var tableContainer = "_n3-4";